import { render, staticRenderFns } from "./Vue2Editor.vue?vue&type=template&id=8c9cfeec&"
import script from "./Vue2Editor.vue?vue&type=script&lang=js&"
export * from "./Vue2Editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports